import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="age-range-filter"
// 年齢の下限/上限ドロップダウン専用の補助コントローラ。
// 初期状態（両方空）で開いた場合のみ、両方が選択されるまで自動close/送信を抑止する。
export default class extends Controller {
  static targets = ["select"]
  static outlets = ["dropdown"]

  initialize() {
    this.dirty = false
    this.openedEmpty = false
  }

  onDropdownOpened() {
    this.openedEmpty = this.selectTargets.every((s) => s.value === "")
  }

  onDropdownClosed() {
    this.submitIfDirty()
  }

  onChange(event) {
    this.dirty = true
    event.stopPropagation()

    if (this.openedEmpty && !this.bothFilled) return

    this.dropdownOutlet.dismiss()
  }

  submitIfDirty() {
    if (!this.dirty) return
    this.dirty = false
    this.element.closest("form")?.requestSubmit()
  }

  get bothFilled() {
    return this.selectTargets.every((select) => select.value !== "")
  }
}
